import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "7f4aa5d6-0132-4397-af16-e53a85ca9559", content: "T = 0,5 s, appropriate for speech", options: {} },
  { id: "222b2c9d-9e38-4ae0-87a7-748ef003a8a2", content: "T = 0,1 s too low for speech", options: {} },
  { id: "1eeb92e1-6e82-4b22-8606-643c492a0e55", content: "T = 0,72 s, too high for speech", options: {} },
  { id: "bb082e56-1d73-47ec-a873-88c19b136246", content: "T = 1 s, too low for speech", options: {} },
];

export const task: Task = {
  id: "bf612913-5d1f-4b5b-928c-5177a338a051",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 1,
  },
  solutionType: "select",
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["1eeb92e1-6e82-4b22-8606-643c492a0e55"],
};
